"use client";

import {CampusesById} from "@/app/types/Campus";
import {ClassesByCampusId} from "@/lib/legacyApi/fetchClassesForCourseByCampusId";
import {useSearchParams} from "next/navigation";
import {useMemo} from "react";
import {ClassRow} from "./AvailableSessionsClassList";
import {
	makeClassDaysId,
	makeClassDaysStringFromId,
} from "@/app/util/classScheduleUtils";
import SelectedClassInstanceLayout from "./SelectedClassInstanceLayout";

export default function SelectedClassInstanceClient({
	classesByCampus,
	campusesById,
}: {
	classesByCampus: ClassesByCampusId;
	campusesById: CampusesById;
}) {
	const selectedSessionId = useSearchParams().get("class_id");

	const academyClassInfo = useMemo(() => {
		if (!selectedSessionId) {
			return null;
		}

		return Object.values(classesByCampus)
			.flat()
			.find((classInfo) => classInfo.classId === selectedSessionId);
	}, [classesByCampus, selectedSessionId]);

	if (!academyClassInfo) {
		return null;
	}

	return (
		<SelectedClassInstanceLayout
			campusLocationName={campusesById[academyClassInfo.campusId].locationName}
		>
			<div className="bg-light-green px-6 py-3 font-overline">
				{makeClassDaysStringFromId(makeClassDaysId(academyClassInfo))}
			</div>
			<div className="border-2 border-solid border-light-green">
				<ClassRow myClass={academyClassInfo} />
			</div>
		</SelectedClassInstanceLayout>
	);
}
